import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[locale]/error.tsx");
